import { useLocation as useLocation } from 'react-router';
import { KProperty02ce7r476m8633 as KProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  setDefaultKeyykye56baz645 as setDefaultKey,
  addChildNodeajp8y977cuss as addChildNode,
  addChildspxcpid5g99g as addChild,
} from '../../../../../../kotlin-react-core/react/ChildrenBuilder.mjs';
import { ReactHTML_instanceofb06f385x0w as ReactHTML_instance } from '../../../../../../kotlin-react-dom/react/dom/html/ReactHTML.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { nfcrfe5635r1kf5 as nfc } from '../../../../../../jsmints-minreact/com/zegreatrob/minreact/ReactFunction.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_LostRoute() {
  _init_properties_LostRoute_kt__xja4tp();
  var tmp = KProperty0();
  return LostRoute$delegate.w1m(null, getPropertyCallableRef('LostRoute', 0, tmp, _get_LostRoute_$ref_d8362j(), null));
}
var LostRoute$delegate;
function LostRoute$delegate$lambda($this$nfc, it) {
  _init_properties_LostRoute_kt__xja4tp();
  var location = useLocation();
  setDefaultKey($this$nfc, '@rdk/9_4');
  // Inline function 'react.dom.html.ReactHTML.div' call
  // Inline function 'react.IntrinsicType' call
  // Inline function 'js.reflect.unsafeCast' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'react.ChildrenBuilder.invoke' call
  var block = ($this$div) => {
    // Inline function 'react.ChildrenBuilder.unaryPlus' call
    // Inline function 'react.ReactNode' call
    // Inline function 'js.reflect.unsafeCast' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$8 = 'Hmm, you seem to be lost. At ' + location.pathname;
    addChildNode($this$div, tmp$ret$8);
    return Unit_instance;
  };
  addChild($this$nfc, 'div', block);
  return Unit_instance;
}
function _get_LostRoute_$ref_d8362j() {
  return () => get_LostRoute();
}
var properties_initialized_LostRoute_kt_fd3esr;
function _init_properties_LostRoute_kt__xja4tp() {
  if (!properties_initialized_LostRoute_kt_fd3esr) {
    properties_initialized_LostRoute_kt_fd3esr = true;
    LostRoute$delegate = nfc(LostRoute$delegate$lambda);
  }
}
//region block: exports
export {
  get_LostRoute as get_LostRoute3by3r5cvpo4mj,
};
//endregion

//# sourceMappingURL=LostRoute.mjs.map
